export const trimRest = (charactersLength, value) => {
  if (value?.length > charactersLength) {
    return `${value.substr(0, charactersLength)}...`;
  }
  return value;
};

export const onlyNumbers = value => value.match(/\d+/) ? value.match(/\d+/)[0] : "";

export const capitalizeFirstLetter = string => string.charAt(0).toUpperCase() + string.slice(1);